// extracted by mini-css-extract-plugin
module.exports = {"hint":"DefaultPlaceholder_hint__dk7to"};